/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import ModelCache from 'scripts/db/model-cache.coffee';
import { getMe } from './members';

/*
 * TEMPORARY HACK TO ENABLE CLASSIC NOTIFICATIONS VIEW IN THE GAMMA
 * HEADER UNTIL THE GAMMA NOTIFICATIONS WORK CAN BE COMPLETED. DO
 * NOT USE ANYTHING IN THIS FILE... OR ELSE... :stare:
 */

export interface ClassicBackboneModelPartial {
  get: (key: string) => any;
  set: (key: string, val: any) => void;
  on: (events: string, callback: any) => void;
  off: (events: string, callback: any) => void;
}

export interface ClassicMemberModelPartial extends ClassicBackboneModelPartial {
  unreadNotifications: (modelCache: ClassicBackboneModelPartial) => number;
  isDismissed: (item: string) => boolean;
  dismiss: (item: string) => void;
  shouldShowSurvey: () => boolean;
  shouldShowMarketingOptIn: () => boolean;
  shouldShowNoticeOfTosChange: () => boolean;
  clearAllNotifications: () => void;
  dismissSurvey: () => void;
  submitSurvey: (surveyData: any) => void;
  setMarketingOptIn: (optedIn: boolean) => void;
  notificationsSeenState: ClassicBackboneModelPartial;
}
// tslint:enable:no-any

export const getClassicMemberModel = (
  state: State,
): ClassicMemberModelPartial | null => {
  const me = getMe(state);
  if (!me) {
    return null;
  }

  return ModelCache.get('Member', me.id) || null;
};

export const getClassicModelCache = (): ClassicBackboneModelPartial =>
  ModelCache;

export const getClassicUnreadNotificationsCount = (state: State): number => {
  const model = getClassicMemberModel(state);
  if (!model) {
    return 0;
  }

  return model.unreadNotifications(ModelCache);
};

export const getClassicUnreadNotificationsCountForCard = (
  state: State,
  idCard: string,
): number => {
  return ModelCache.all('Notification').filter(
    (notification: ClassicBackboneModelPartial) => {
      const unread = notification.get('unread');
      const data = notification.get('data');

      return unread && data && data.card && data.card.id === idCard;
    },
  ).length;
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/classic.ts